import React from "react";
import { Card, StyledBody, StyledTitle } from "baseui/card";
import { DisplaySmall } from "baseui/typography";
import { colors } from "baseui/tokens";
import { FaTools, FaClipboardList, FaStickyNote, FaCamera } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";

function Dashboard() {
  const cardStyle = {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "1rem",
  };

  const iconStyle = {
    fontSize: "2.5rem",
    marginBottom: "0.5rem",
    color: colors.green800,
  };

  const gridContainerStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "16px",
    padding: "1rem",
    maxWidth: "1200px",
    margin: "0 auto",
  };

  const buttonStyle = {
    marginTop: "1rem",
    padding: "1rem",
    fontSize: "1rem",
    backgroundColor: colors.green600,
    border: "none",
    borderRadius: "4px",
    color: "#fff",
    cursor: "pointer",
    width: "100%"
  };

  return (
    <div>
      <div style={{ marginTop: '1rem', marginLeft: '1rem' }}>
        <StyledTitle style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <FaTools style={iconStyle} />
          Service Dashboard
        </StyledTitle>
        <StyledBody>
          <DisplaySmall>Welcome, Tech Team!</DisplaySmall>
          <p>This area will soon include job tickets, updates, and tasks.</p>
        </StyledBody>
      </div>
      
      <div style={gridContainerStyle}>
      <Card
        overrides={{
          Root: {
            style: {
              ...cardStyle,
              backgroundColor: colors.teal200,
              height: "250px",
            },
          },
        }}
      >
        <StyledTitle style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <FaClipboardList style={iconStyle} />
          Work Queue
        </StyledTitle>
        <StyledBody>
          <p>Placeholder for vehicle work queue or repair status list.</p>
        </StyledBody>
      </Card>

      <Card
        overrides={{
          Root: {
            style: {
              ...cardStyle,
              backgroundColor: colors.mint200,
              height: "250px",
            },
          },
        }}
      >
        <StyledTitle style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <FaStickyNote style={iconStyle} />
          Notes / Updates
        </StyledTitle>
        <StyledBody>
          <p>You can add service notes, updates, or reminders here soon.</p>
        </StyledBody>
      </Card>

      <Card
        overrides={{
          Root: {
            style: {
              ...cardStyle,
              backgroundColor: colors.yellow200,
              height: "250px",
            },
          },
        }}
      >
        <StyledTitle style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <FaCamera style={iconStyle} />
          Photo Upload
        </StyledTitle>
        <StyledBody>
          <p>Upload and manage vehicle photos directly from the dashboard.</p>
          <Link to="/upload-vehicle-photos">
            <Button variant="primary" className="photo-upload" style={buttonStyle}>Go to Photo Upload</Button>
          </Link>
        </StyledBody>
      </Card>
    </div>
    </div>
    
  );
}

export default Dashboard;
